import React from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from '../../contexts/translation';
import { Columns } from '../../pages/FaultType/Columns';
import { STORAGE_KEYS } from '../../utils/localStorageKeys';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';

export const FaultTypesDataGrid = ({ data, handleEdit }: IDataGrid) => {
  const { translate } = useTranslation();
  const transFormName = 'FaultType.List';
  const history = useHistory();

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        html: translate!('Fault types', transFormName),
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          type: 'default',
          stylingMode: 'contained',
          onClick: () => history.push(`/fault-types/new/`),
        },
      },
    );
  };
  return (
    <>
      <SisDataGrid
        data={data}
        keyExpr={'id'}
        transFormName={transFormName}
        columns={Columns(handleEdit, data, translate)}
        onCellDblClick={(e) => handleEdit && handleEdit(e)}
        columnChooser={false}
        allowColumnResizing={false}
        allowColumnReordering={false}
        onToolbarPreparing={onToolbarPreparing}
        pageSizeChangeVisible
        stateStoringKey={STORAGE_KEYS.FAULT_TYPE_DATAGRID}
      />
    </>
  );
};
